import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

function useLandingPageHandler() {
    const navigate = useNavigate();
    const routesLocation = useLocation();
    const { setup: { marketPackage } } = useSelector((state) => state.buildTargets);

    useEffect(() => { // On refresh back to landing page
        if ((routesLocation.pathname.includes("report-builder")
        || routesLocation.pathname.includes("one")
        || routesLocation.pathname.includes("advanced")) && !marketPackage) {
            navigate("/");
        }
    }, [routesLocation, marketPackage]);

    
    return null
}

export default useLandingPageHandler;
